import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24564fd7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wrapper"
}
const _hoisted_2 = { class: "banner" }
const _hoisted_3 = {
  key: 0,
  class: "congratulation"
}
const _hoisted_4 = {
  key: 0,
  src: "https://res-cn.public.gblinker.com/gblinker/wechat_mini/successfully-ordered.svg",
  mode: "widthFix"
}
const _hoisted_5 = {
  key: 1,
  src: "https://res-cn.public.gblinker.com/gblinker/wechat_mini/successfully-payed.svg",
  mode: "widthFix"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 支付成功 ", -1))
const _hoisted_7 = {
  key: 1,
  class: "congratulation"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 下单成功 ", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 2,
  class: "pay-amount"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "共计支付金额", -1))
const _hoisted_12 = { class: "number price" }
const _hoisted_13 = { class: "tips" }
const _hoisted_14 = {
  key: 3,
  class: "thanks-for-you"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "感谢您使用 GBLinker 跨境物流服务", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "支付完成后我们会及时将包裹寄出，请留意路由信息。", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "container" }
const _hoisted_19 = {
  key: 0,
  class: "g-card warehouse-address"
}
const _hoisted_20 = { class: "item" }
const _hoisted_21 = { class: "name" }
const _hoisted_22 = { class: "item" }
const _hoisted_23 = { class: "text" }
const _hoisted_24 = { class: "item" }
const _hoisted_25 = { class: "text" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tips" }, " 提示：请将你的物品及时寄往中转仓，收到货物后我们会拆箱测量并向您发送支付通知 ", -1))
const _hoisted_27 = { class: "g-card order-info" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "title" }, " 订单信息 ")
], -1))
const _hoisted_29 = { class: "body" }
const _hoisted_30 = { class: "receiver-info" }
const _hoisted_31 = { class: "item" }
const _hoisted_32 = { class: "text" }
const _hoisted_33 = { class: "item" }
const _hoisted_34 = { class: "text" }
const _hoisted_35 = { class: "item" }
const _hoisted_36 = { class: "text" }
const _hoisted_37 = { class: "footer" }
const _hoisted_38 = { class: "item" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " 包裹单号 ", -1))
const _hoisted_40 = { class: "text" }
const _hoisted_41 = {
  key: 0,
  class: "item"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " 收件国家 ", -1))
const _hoisted_43 = { class: "view-item" }
const _hoisted_44 = ["src"]
const _hoisted_45 = { class: "text" }
const _hoisted_46 = { class: "item" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " 国内快递单号 ", -1))
const _hoisted_48 = {
  key: 0,
  class: "text"
}
const _hoisted_49 = { class: "item" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " 线路 ", -1))
const _hoisted_51 = { class: "text" }
const _hoisted_52 = {
  key: 0,
  class: "g-modal is-center logistics-code"
}
const _hoisted_53 = { class: "g-modal-body" }
const _hoisted_54 = { class: "modal-content" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 添加快递单号 ", -1))
const _hoisted_56 = { class: "logistics-code-input" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_ctx.packageInfo)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.type=='pay')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                ( _ctx.packageInfo.statusPay === 2 )
                  ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                  : (_openBlock(), _createElementBlock("img", _hoisted_5)),
                _hoisted_6
              ]))
            : _createCommentVNode("", true),
          (_ctx.type=='order')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
            : _createCommentVNode("", true),
          (_ctx.type=='pay')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, " ￥" + _toDisplayString(_ctx.packageInfo.price), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, " 订单创建时间：" + _toDisplayString(_ctx.packageInfo.created), 1),
          (_ctx.type=='pay')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_17))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_18, [
          (_ctx.displayWareHouse)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_Icon, {
                    class: "icon",
                    icon: "icon_user"
                  }),
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.displayWareHouse.name?_ctx.displayWareHouse.name:_ctx.displayWareHouse.title), 1)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_Icon, {
                    class: "icon",
                    icon: "icon_phone"
                  }),
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.displayWareHouse.phone), 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_Icon, {
                    class: "icon",
                    icon: "icon_address"
                  }),
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.displayWareHouse.state) + _toDisplayString(_ctx.displayWareHouse.city) + " " + _toDisplayString(_ctx.displayWareHouse.address1) + _toDisplayString(_ctx.displayWareHouse.address2||''), 1)
                ]),
                _createElementVNode("div", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyAddress(_ctx.displayWareHouse))),
                  class: "copy-to-paste"
                }),
                _hoisted_26
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_Icon, {
                    class: "icon",
                    icon: "icon_user"
                  }),
                  _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.packageInfo.firstname) + " " + _toDisplayString(_ctx.packageInfo.lastName), 1)
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_Icon, {
                    class: "icon",
                    icon: "icon_phone"
                  }),
                  _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.packageInfo.mobile), 1)
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_Icon, {
                    class: "icon",
                    icon: "icon_address"
                  }),
                  _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.packageInfo.address1) + " " + _toDisplayString(_ctx.packageInfo.address2||'') + ", " + _toDisplayString(_ctx.packageInfo.city) + " , " + _toDisplayString(_ctx.packageInfo.state) + " " + _toDisplayString(_ctx.packageInfo.zipcode) + ", " + _toDisplayString(_ctx.packageInfo.country), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.packageInfo.packageNum), 1)
                ]),
                (_ctx.displayCountryInfo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("img", {
                          class: "country-icon",
                          src: _ctx.displayCountryInfo.icon
                        }, null, 8, _hoisted_44),
                        _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.displayCountryInfo.nameCn), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_46, [
                  _hoisted_47,
                  (_ctx.packageInfo.logisticsCode)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(_ctx.packageInfo.logisticsCode), 1))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openLogisticsModal && _ctx.openLogisticsModal(...args))),
                        "hover-class": "hover",
                        class: "g-button g-button-primary g-button-plain"
                      }, " 立即填写 "))
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.packageInfo.express.title||'-'), 1)
                ])
              ])
            ])
          ])
        ]),
        (_ctx.dialogVisiable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", {
                  class: "g-modal-close",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeLogisticsModal && _ctx.closeLogisticsModal(...args)))
                }, [
                  _createVNode(_component_Icon, { icon: "btn_cancel" })
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _hoisted_55,
                  _createElementVNode("div", _hoisted_56, [
                    _withDirectives(_createElementVNode("input", {
                      type: "g-input",
                      "cursor-spacing": "100",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.logisticsCode) = $event)),
                      placeholder: "填写购物平台发货的快递单号"
                    }, null, 512), [
                      [_vModelText, _ctx.logisticsCode]
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  "hover-class": "hover",
                  class: "g-button g-button-primary",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.updateCode && _ctx.updateCode(...args)))
                }, " 保存 ")
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}